/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { InvitationStateEnum } from './invitationStateEnum';
import { RelativeStatusEnum } from './relativeStatusEnum';
import { RelativeTypeEnum } from './relativeTypeEnum';

export interface CloseRelativeList { 
    readonly id: string;
    relativeType: RelativeTypeEnum;
    status: RelativeStatusEnum;
    firstName: string;
    lastName: string;
    email?: string;
    phone?: string;
    note?: string;
    isPrimary?: boolean;
    readonly invitationState: InvitationStateEnum;
}